export const calculateContentScore = (
  matches: Record<string, number> = {},
): number => {
  const entries = Object.entries(matches);
  const contentScore = entries.reduce((acc, [, count]) => {
    return acc + Math.min(count, 2);
  }, 0);
  return contentScore;
};
